import { baseUrl } from '@/api/types';

// company contracts urls
export function companyContractsIndexUrl() {
  return `${baseUrl}/company-contracts`;
}

export function companyContractsCreateUrl() {
  return `${companyContractsIndexUrl()}/create`;
}

export function companyContractsStoreUrl() {
  return `${companyContractsIndexUrl()}/store`;
}

export function companyContractsEditUrl(hashedId) {
  return `${companyContractsIndexUrl()}/${hashedId}/edit`;
}

export function companyContractsUpdateUrl(hashedId) {
  return `${companyContractsIndexUrl()}/${hashedId}`;
}

export function companyContractsDeleteUrl(hashedId) {
  return `${companyContractsIndexUrl()}/${hashedId}`;
}

export function companyContractsDetailsUrl(hashedId) {
  return `${companyContractsIndexUrl()}/${hashedId}/details`;
}

export function companyContractsFileFormUrl() {
  return `${companyContractsIndexUrl()}/files`;
}

export function companyContractsPaymentIndexUrl() {
  return `${baseUrl}/company-contracts-payments`;
}

export function companyContractsPaymentShowUrl(hashedId) {
  return `${baseUrl}/company-contracts-payments/${hashedId}`;
}

export function companyContractsPaymentStoreUrl(hashedId) {
  return `${companyContractsPaymentShowUrl(hashedId)}/store`;
}

export function companyContractsSinglePaymentStoreUrl(hashedId) {
  return `${baseUrl}/company-contracts-single-payments/${hashedId}/store`;
}

export function companyContractsSinglePaymentUpdateUrl(hashedId) {
  return `${baseUrl}/company-contracts-single-payments/${hashedId}/update`;
}

export function companyContractsSinglePaymentDeleteUrl(hashedId) {
  return `${baseUrl}/company-contracts-single-payments/${hashedId}`;
}

export function companyContractsChartIndexUrl() {
  return `${baseUrl}/company-contracts-chart`;
}

export function companyContractRestoreUrl(contractId) {
  return `${baseUrl}/company-contracts-restore/${contractId}`;
}

export function companyContractPaymentLink() {
  return `${baseUrl}/company-contract-payment-link`;
}

export function companyContractUnlinkInvoiceUrl(hashedId, hashedInvoiceId) {
  return `${baseUrl}/company-contract-payment-unlink/${hashedId}/${hashedInvoiceId}`;
}

export function companyContractArchiveStoreUrl(hashedId) {
  return `${companyContractsIndexUrl()}/${hashedId}/archive`;
}

export function companyContractPaymentMassActionUrl() {
  return `${companyContractsPaymentIndexUrl()}/mass-actions`;
}
